// @flow

/**
 * Returns an object with the given properties filtered out
 *
 * @param {Object} targetObj - the object to be filtered
 * @param {Array} propsToRemove - an array of strings for the properties to be removed
 * @return {Object}
 */

export default function filterProps(targetObj: Object = {}, propsToRemove: Array<string> = []) {
  return Object.keys(targetObj).reduce(
    (acc, cur) =>
      propsToRemove.includes(cur)
        ? acc
        : {
            ...acc,
            [cur]: targetObj[cur],
          },
    {},
  );
}
